import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/gloable.css'
import request from '@/request/request'

Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.request = request

router.beforeEach((to, from, next)=>{

  if(to.path === '/register' || to.path === '/login2' || to.path === '/'){ //若是进入登录与注册页面 ==> pass
    // if(to.path === '/register' || to.path === '' || to.path === '/'){
    console.log("-----------------login--------------")
    next()
  }else{
    let userToken = localStorage.getItem('token');
    // console.log("Token为:"+userToken);
    if(userToken == null || userToken == ''){
      alert("无权限，请先登录!");
      return next('/');
    }else{
      next();
    }
  }

})

// router.afterEach(to =>{
//   sessionStorage.setItem('routerTo', JSON.stringify(to))
// })


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
